module.exports = __webpack_public_path__ + "img/3.602ba231.png";